export default __webpack_public_path__ + "static/media/no.3a07313d.svg";